

import ApiService from "./axios/Apiservices";

// STORE CONTACT
export const createContact = async (data) => {
    return ApiService.post("/contact-us", data);
};

// // GET ALL CONTACTS
// export const getContacts = async () => {
//     return ApiService.get("/admin/contacts");
// };

//  export const getContactDetails = async (id) => {
//     return ApiService.get(`/admin/contact/details/${id}`);
// };

//  export const updateContactStatus = async (data) => {
//     return ApiService.post("/admin/contact/update-status", data);
// };

//  export const deleteContact = async (id) => {
//     return ApiService.delete(`/admin/contact/destroy/${id}`);
// };